<template>
    <div class="az-form-content">
        <ModalResponderEsclarecimentoImpugnacao
                v-if="modalResposta"
                v-model="modalResposta"
                @fecharModal="fecharModalEsclarecimento"
                :item="impugnacaoSelecionado"
                tipo="Impugnação"
                :esclarecimento="false"
        />
        <ModalVisualizarRespostaEsclarecimentoImpugnacao
                v-if="modalVisualizacao"
                v-model="modalVisualizacao"
                @fecharModalVisualizacao="fecharModalVisualizacao"
                :item="impugnacaoSelecionado"
        />
        <v-container fluid grid-list-xl>
            <v-layout wrap align-center>
                <v-flex xs12 sm12 d-flex>
                    <span class="az-subtitle primary--text">Impugnações</span>
                </v-flex>
                <v-flex xs12 sm12 d-flex>
                    <v-data-table v-if="impugnacoes.length > 0"
                                  :headers="colunas"
                                  :items="impugnacoes"
                                  :loading="false"
                                  hide-actions
                                  class="az-table-list table-dados-esclarecimentos"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <td>
                                    <span>{{ props.item.dataCadastro | azDate('DD/MM/YYYY HH:mm') }}</span>
                                </td>
                                <td>
                                    <span v-if="props.item.fornecedor && props.item.fornecedor.razaoSocial">
                                      {{ props.item.fornecedor.razaoSocial }}
                                    </span>
                                    <span v-else-if="props.item.nomeRazaoSocial">
                                      {{ props.item.nomeRazaoSocial }}
                                    </span>
                                    <span v-else>
                                      --
                                    </span>
                                </td>
                                <td class="d-inline-block text-truncate max-25">{{ props.item.assunto }}</td>
                                <td>
                                    <span>{{ possuiAnexo(props.item) }}</span>
                                </td>
                                <td>{{ props.item.situacao | azEnum(tiposSituacaoEsclarecimentoImpugnacao) }}</td>
                                <td class="table-actions">
                                    <div>
                                        <a v-if="props.item.relatorioUri" :href="criarLinkDownload(props.item.relatorioUri)" target="_blank"
                                           title="Download Relatório" class="az-action-link-icon">
                                            <v-icon>get_app</v-icon>
                                        </a>
                                        <a v-if="exibirModalResposta(props.item)" title="Responder" @click="abrirModalResposta(props.item)">
                                            <v-icon>reply</v-icon>
                                        </a>
                                        <a @click="abrirModalVisualizacao(props.item)" title="Visualizar">
                                            <v-icon>search</v-icon>
                                        </a>
                                        <a v-if="exibirModalSolicitacao(props.item)" @click="abrirModalSolicitacaoEdicao(props.item)" title="Editar">
                                          <v-icon>edit</v-icon>
                                        </a>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <v-flex xs12 sm12 d-flex v-if="!impugnacoes.length && !editando">
                        <az-ops title="Nenhuma impugnação encontrada."
                                message="Este processo não possui nenhuma impugnação até o momento."
                        ></az-ops>
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-container>
        <credenciamento-fornecedor-esclarecimento-solicitacao :item="itemSelecionado"
                                                              :solicitacao="solicitacaoSelecionada"
                                                              v-if="exibirModalSolicitacaoEdicao"
                                                              @fecharDetalhe="fecharDetalhe()"
                                                              @solicitacaoSalva="buscaTodos()"
                                                              @solicitacaoEnviada="buscaTodos()"
                                                              @solicitacaoEditada="buscaTodos()"
        ></credenciamento-fornecedor-esclarecimento-solicitacao>
    </div>
</template>

<script>
import {tiposSituacaoEsclarecimentoImpugnacao} from '@/commons/constants'
    import ModalResponderEsclarecimentoImpugnacao from './Modal/ModalResponderEsclarecimentoImpugnacao.vue'
    import ModalVisualizarRespostaEsclarecimentoImpugnacao
        from "./Modal/ModalVisualizarRespostaEsclarecimentoImpugnacao.vue";
    import {mapState} from "vuex";
import CredenciamentoFornecedorEsclarecimentoSolicitacao
  from "@/views/credenciamento/detalhe-credenciamento/fornecedor/modal/CredenciamentoFornecedorEsclarecimentoSolicitacao.vue";
import moment from "moment/moment";

    export default {
        name: 'CredenciamentoImpugnacaoTabela',
        components: {
          CredenciamentoFornecedorEsclarecimentoSolicitacao,
          ModalVisualizarRespostaEsclarecimentoImpugnacao, ModalResponderEsclarecimentoImpugnacao},
        inject: ['$validator'],
        props: ['editando', 'impugnacoes'],
        data() {
            return {
                modalResposta: false,
                modalVisualizacao: false,
                impugnacaoSelecionado: null,
                licitacaoId: undefined,
                repository: 'repo1:licitacao',
                tiposSituacaoEsclarecimentoImpugnacao,
                exibirModalSolicitacaoEdicao: false,
                exibirModalLimiteEsclarecimentoImpugnacao: false,
                itemSelecionado: null,
                solicitacaoSelecionada: null,
            }
        },
        computed:{
            ...mapState(['licitacao']),
            colunas(){
                return this.criarColunas(6,
                    ['Data','Empresa','Assunto Impugnação','Anexo','Situação', 'Ações'],
                    [],
                    [false,false,false,false,false, false],
                    ['left','left','left','left','left','center'],
                    ['15%','15%','25%','10%','20%', '15%'],
                    'primary--text')
            }
        },
        methods: {
            possuiAnexo(item){
                if(item.arquivoUri){
                    return 'Sim'
                }else{
                    return 'Não'
                }
            },
            abrirModalVisualizacao(item){
                this.modalVisualizacao = true
                this.impugnacaoSelecionado = item
            },
            abrirModalSolicitacaoEdicao(item) {
                this.itemSelecionado = item.tipo || 'IMPUGNACAO'
                this.solicitacaoSelecionada = item
                if(this.validaDataLimiteEsclarecimentoImpugnacao()) {
                  this.exibirModalLimiteEsclarecimentoImpugnacao = true
                } else {
                  this.exibirModalSolicitacaoEdicao = true
                }
            },
            validaDataLimiteEsclarecimentoImpugnacao(){
                return moment().isAfter(this.licitacao.dataLimiteEsclarecimentoImpugnacao)
            },
            exibirModalResposta(item){
                return !(!this.licitacao.usuarioComissao || !this.licitacao.esclarecimentoImpugnacao || item.situacao == 'RASCUNHO');
            },
            exibirModalSolicitacao(item){
                return item.situacao === 'RASCUNHO';
            },
            abrirModalResposta(item){
                if(!this.licitacao.usuarioComissao){
                  this.mostrarNotificacaoErro('Usuario não possui permissão para responder.')
                  return
                }
                if(!this.licitacao.esclarecimentoImpugnacao){
                  this.mostrarNotificacaoErro("Não é possível responder, habilite a funcionalidade de esclarecimento e impugnação!")
                  return
                }
                this.modalResposta = true
                this.impugnacaoSelecionado = item
            },
            fecharModalEsclarecimento(){
                this.modalResposta = false
                this.impugnacaoSelecionado = null
                this.$emit('buscarImpugnacoes')
            },
            fecharModalVisualizacao(){
                this.modalVisualizacao = false
                this.impugnacaoSelecionado = null
                this.$emit('buscarImpugnacoes')
            },
            fecharDetalhe(){
              this.exibirModalSolicitacaoEdicao = false
              this.$emit('buscarImpugnacoes')
            },
            buscaTodos(){
                this.$emit('buscarImpugnacoes')
                this.exibirModalSolicitacaoEdicao = false;
                this.itemSelecionado = null;
                this.solicitacaoSelecionada = null;
            }
        }
    }
</script>

<style scoped lang="stylus">

    .teste {
      padding-bottom: 100px !important;
    }
    .table-status
        &__error i
            font-size: 18px
            color: #d79641

    .table-dados-esclarecimentos
        td
            color #777 !important
        padding-bottom 60px

    @media (max-width: 720px)
        .table-dados-esclarecimentos

            td:nth-of-type(1):before
                display none

            td:nth-of-type(2):before
                content: "Tipo:"

            td:nth-of-type(3):before
                content: "Data:"

            td:nth-of-type(4):before
                content: "Nome:"

            td:nth-of-type(5):before
                display none

</style>
